import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

// Async action to fetch book same day cleaning list data
export const getResetPasswordList = createAsyncThunk(
  "resetPasswordList/getResetPasswordList",
  async (data, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/api/auth/reset-password`,
        data,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data || { message: error.message }
      );
    }
  }
);

const resetPasswordSlice = createSlice({
  name: "resetPasswordList",
  initialState: {
    loading: false,
    resetPasswordData: null,
    error: null,
  },
  reducers: {
    ResetPasswordState: (state) => {
      state.loading = false;
      state.resetPasswordData = null;
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getResetPasswordList.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getResetPasswordList.fulfilled, (state, action) => {
        state.loading = false;
        state.resetPasswordData = action.payload;
      })
      .addCase(getResetPasswordList.rejected, (state, action) => {
        state.loading = false;
        state.resetPasswordData = action.payload;
        state.error = action.payload;
      });
  },
});

export const { ResetPasswordState } = resetPasswordSlice.actions;
export default resetPasswordSlice.reducer;
